var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-tm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h496.06v496.06H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#28ae66",
    d: "M0 0h744.09v496.06H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.117 133.217c27.032 13.035 59.219-.061 70.864-18.056 11.94-16.794 13.406-44.993-7.236-70.866 32.04 26.572 39.123 56.693 23.183 81.497-21.262 28.344-68.43 27.524-86.811 7.425z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.921 76.181l1.534-5.37-4.36-3.345 5.436-.162L301.276 62l1.83 5.272 5.44.069-4.306 3.419 1.614 5.347-4.489-3.16zm-26.85 33.661l1.534-5.37-4.36-3.345 5.436-.162 1.745-5.304 1.83 5.272 5.44.069-4.306 3.419 1.614 5.347-4.489-3.16zm1.77-26.567l1.534-5.37-4.36-3.345 5.436-.162 1.745-5.304 1.83 5.272 5.44.069-4.306 3.419 1.614 5.347-4.489-3.16zm0-26.582l1.534-5.37-4.36-3.346 5.436-.161 1.745-5.304 1.83 5.271 5.44.07-4.306 3.418 1.614 5.348-4.489-3.16zm-29.84 33.668l1.534-5.37-4.36-3.345 5.436-.162 1.745-5.304 1.83 5.272 5.44.069-4.306 3.419 1.614 5.347-4.489-3.16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M46.063 0h159.45v496.06H46.063z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.064 129.33v-3.544l6.591-8.858-1.329-1.772 3.986-5.315-1.328-1.771-2.658 3.543-1.329-1.772L59.3 97.44l1.328 1.772-1.328 1.771 2.739 3.58 6.562-8.895-6.673-8.62-2.628 3.305 1.328 1.772-1.328 1.772-9.302-12.402 1.33-1.772 2.657 3.544 1.328-1.772-3.986-5.315 1.33-1.772-6.592-8.858v-3.543l9.248 12.401-1.328 1.772 3.986 5.315-2.658 3.543 2.658 3.543 3.986-5.314L71.31 95.88l-9.354 12.19-3.986-5.315-2.658 3.543 2.658 3.543-3.986 5.316 1.328 1.771-9.248 12.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.063 85.04l1.329 3.543v5.315h3.986l2.657 1.772-2.657 1.771h-3.986v5.315l-1.33 3.544V85.04z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.064 214.368v-3.543l6.591-8.858-1.329-1.772 3.986-5.315-1.328-1.771-2.658 3.543-1.329-1.772 9.303-12.4 1.328 1.771-1.328 1.772 2.739 3.58 6.562-8.895-6.673-8.62-2.628 3.305 1.328 1.772-1.328 1.772-9.302-12.402 1.33-1.772 2.657 3.544 1.328-1.772-3.986-5.315 1.33-1.772-6.592-8.858v-3.543l9.248 12.402-1.328 1.771 3.986 5.315-2.658 3.543 2.658 3.543 3.986-5.314 9.354 12.612-9.354 12.191-3.986-5.315-2.658 3.543 2.658 3.543-3.986 5.315 1.328 1.772-9.248 12.401z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.063 170.079l1.329 3.543v5.315h3.986l2.657 1.772-2.657 1.771h-3.986v5.315l-1.33 3.544v-21.26z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.065 299.409v-3.543l6.591-8.859-1.329-1.772 3.986-5.315-1.328-1.771-2.658 3.543-1.329-1.772 9.302-12.4 1.328 1.772-1.328 1.772 2.739 3.579 6.562-8.895-6.673-8.62-2.628 3.305 1.328 1.772-1.328 1.772-9.302-12.402 1.33-1.772 2.657 3.544 1.328-1.772-3.986-5.315 1.33-1.771-6.592-8.858v-3.544l9.248 12.402-1.328 1.771 3.986 5.315-2.658 3.543 2.658 3.544 3.986-5.315 9.354 12.613-9.354 12.19-3.986-5.315-2.658 3.543 2.658 3.543-3.986 5.315 1.328 1.772-9.248 12.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.064 255.119l1.329 3.543v5.315h3.986l2.657 1.772-2.657 1.771h-3.986v5.315l-1.33 3.544v-21.26z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.065 379.13v-3.543l6.591-8.859-1.329-1.772 3.986-5.315-1.328-1.771-2.658 3.543-1.329-1.772L59.3 347.24l1.328 1.772-1.328 1.772 2.739 3.579 6.562-8.895-6.673-8.62-2.628 3.305 1.328 1.772-1.328 1.772-9.302-12.402 1.33-1.772 2.657 3.544 1.328-1.772-3.986-5.315 1.33-1.772-6.592-8.858v-3.543l9.248 12.402-1.328 1.771 3.986 5.315-2.658 3.543 2.658 3.543 3.986-5.314 9.354 12.613-9.354 12.19-3.986-5.315-2.658 3.543 2.658 3.543-3.986 5.315 1.328 1.772-9.248 12.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.064 334.84l1.329 3.543v5.315h3.986l2.657 1.772-2.657 1.771h-3.986v5.315l-1.33 3.544v-21.26z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.51 129.33v-3.544l-6.592-8.858 1.329-1.772-3.986-5.315 1.328-1.771 2.658 3.543 1.329-1.772-9.302-12.401-1.328 1.772 1.328 1.771-2.739 3.58-6.562-8.895 6.673-8.62 2.628 3.305-1.328 1.772 1.328 1.772 9.302-12.402-1.33-1.772-2.657 3.544-1.328-1.772 3.986-5.315-1.33-1.772 6.592-8.858v-3.543l-9.248 12.401 1.328 1.772-3.986 5.315 2.658 3.543-2.658 3.543-3.986-5.314-9.354 12.613 9.354 12.19 3.986-5.315 2.658 3.543-2.658 3.543 3.986 5.316-1.328 1.771 9.248 12.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51 85.04l-1.329 3.543v5.315h-3.986l-2.657 1.772 2.657 1.771h3.986v5.315l1.33 3.544V85.04z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.95 214.37v-3.544l-6.592-8.858 1.329-1.772-3.986-5.315 1.328-1.771 2.658 3.543 1.329-1.772-9.302-12.401-1.328 1.772 1.328 1.771-2.739 3.58-6.562-8.895 6.673-8.62 2.628 3.305-1.328 1.772 1.328 1.772 9.302-12.402-1.33-1.772-2.657 3.544-1.328-1.772 3.986-5.315-1.33-1.772 6.592-8.858v-3.543l-9.248 12.402 1.328 1.771-3.986 5.315 2.658 3.543-2.658 3.543-3.986-5.314-9.354 12.613 9.354 12.19 3.986-5.315 2.658 3.544-2.658 3.543 3.986 5.315-1.328 1.771 9.248 12.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.95 170.08l-1.329 3.543v5.315h-3.986l-2.657 1.772 2.657 1.771h3.986v5.315l1.33 3.544v-21.26z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.51 299.409v-3.543l-6.592-8.859 1.329-1.772-3.986-5.315 1.328-1.771 2.658 3.543 1.329-1.772-9.302-12.401-1.328 1.772 1.328 1.772-2.739 3.579-6.562-8.895 6.673-8.62 2.628 3.305-1.328 1.772 1.328 1.772 9.302-12.402-1.33-1.772-2.657 3.544-1.328-1.772 3.986-5.315-1.33-1.771 6.592-8.858v-3.544l-9.248 12.402 1.328 1.771-3.986 5.315 2.658 3.543-2.658 3.544-3.986-5.315-9.354 12.613 9.354 12.19 3.986-5.315 2.658 3.543-2.658 3.543 3.986 5.315-1.328 1.772 9.248 12.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51 255.119l-1.329 3.543v5.315h-3.986l-2.657 1.772 2.657 1.771h3.986v5.315l1.33 3.544v-21.26z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.51 379.13v-3.543l-6.592-8.859 1.329-1.772-3.986-5.315 1.328-1.771 2.658 3.543 1.329-1.772-9.302-12.401-1.328 1.772 1.328 1.772-2.739 3.579-6.562-8.895 6.673-8.62 2.628 3.305-1.328 1.772 1.328 1.772 9.302-12.402-1.33-1.772-2.657 3.544-1.328-1.772 3.986-5.315-1.33-1.772 6.592-8.858v-3.543l-9.248 12.402 1.328 1.771-3.986 5.315 2.658 3.543-2.658 3.543-3.986-5.314-9.354 12.613 9.354 12.19 3.986-5.315 2.658 3.543-2.658 3.543 3.986 5.315-1.328 1.772 9.248 12.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51 334.84l-1.329 3.543v5.315h-3.986l-2.657 1.772 2.657 1.771h3.986v5.315l1.33 3.544v-21.26z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.067 33.66v-3.543l6.591-8.858-1.329-1.772 3.986-5.315-1.328-1.771-2.658 3.543L50 14.172l9.302-12.401 1.328 1.771-1.328 1.772 2.739 3.58 6.562-8.895h2.71L61.959 12.4l-3.986-5.315-2.658 3.543 2.658 3.543-3.986 5.315 1.328 1.772-9.248 12.401zm0-33.66h7.972l-2.657 1.772h-3.986v5.315l-1.33 3.543V0zM205.506 33.66v-3.543l-6.591-8.858 1.329-1.772-3.986-5.315 1.328-1.771 2.658 3.543 1.328-1.772-9.3-12.401-1.33 1.771 1.33 1.772-2.74 3.58-6.562-8.895h-2.71l9.354 12.402 3.986-5.315 2.658 3.543-2.658 3.543 3.986 5.315-1.328 1.772 9.248 12.401zm0-33.66h-7.972l2.657 1.772h3.986v5.315l1.33 3.543V0z",
    strokeWidth: "1pt",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51 488.996s5.72-10.044 20.136-13.087c14.416-3.044 16.933 6.696 25.17 6.696 8.238 0 21.28-6.696 21.28-6.696s-13.042 12.783-23.11 12.478c-10.068-.303-13.5-6.695-23.797-5.782-10.297.913-19.679 6.696-19.679 6.391z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.34 488.996s-5.72-10.044-20.136-13.087c-14.416-3.044-16.933 6.696-25.17 6.696-8.238 0-21.28-6.696-21.28-6.696s13.042 12.783 23.11 12.478c10.068-.303 13.5-6.695 23.797-5.782 10.297.913 19.679 6.696 19.679 6.391z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.201 472.38c-1.27-2.657-4.442-14.251-2.75-15.701 2.538-.966 9.307 10.87 8.673 21.5-4.442 2.415-19.461-.967-19.25-4.108 1.058-4.348 9.52-2.898 13.327-1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.124 462.247c-.83-2.95-2.14-15.168-.26-16.12 2.633-.247 7.424 13.198 5.158 23.423-4.72 1.14-18.892-6.302-18.2-9.317 1.709-3.963 9.763-.216 13.302 2.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.749 450.91c-.563-3.06-.775-15.4 1.176-16.048 2.637.172 6.197 14.28 3.037 24.074-4.789.386-18.198-9.247-17.242-12.13 2.049-3.666 9.713 1.33 13.029 4.103z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.933 438.835c-.2-3.139 1.024-15.373 3.028-15.61 2.585.715 4.462 15.388.201 24.41-4.775-.608-16.903-12.895-15.623-15.547 2.45-3.197 9.441 3.322 12.394 6.747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.889 426.187c.14-3.144 2.67-15.017 4.677-14.868 2.481 1.203 2.759 16.083-2.43 24.196-4.66-1.517-15.339-16-13.786-18.378 2.769-2.695 8.985 5.095 11.539 9.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.018 411.796c-.344 12.593-2.633 12.74-6.811 3.432-1.85-3.517-2.078-18.122-.412-18.666 2.409-.05 7.157 10.365 7.223 15.234z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#faae29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.932 473.706c1.27-2.657 4.442-14.252 2.75-15.701-2.538-.966-9.307 10.87-8.673 21.5 4.442 2.414 19.461-.967 19.25-4.108-1.058-4.348-9.52-2.898-13.327-1.691z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.009 463.572c.83-2.949 2.14-15.167.26-16.12-2.633-.246-7.424 13.199-5.158 23.424 4.72 1.14 18.892-6.302 18.2-9.317-1.709-3.963-9.763-.216-13.302 2.013z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.384 452.235c.563-3.06.775-15.399-1.176-16.047-2.637.172-6.197 14.28-3.037 24.074 4.789.386 18.198-9.247 17.242-12.13-2.049-3.666-9.713 1.33-13.029 4.103z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2 440.161c.2-3.139-1.024-15.373-3.028-15.61-2.585.715-4.462 15.388-.201 24.41 4.775-.608 16.903-12.895 15.623-15.547-2.45-3.197-9.441 3.322-12.394 6.747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.244 427.513c-.14-3.144-2.67-15.017-4.677-14.868-2.481 1.202-2.759 16.083 2.43 24.196 4.66-1.517 15.339-16 13.786-18.378-2.769-2.695-8.985 5.095-11.539 9.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.115 413.122c.344 12.593 2.633 12.74 6.811 3.432 1.85-3.517 2.078-18.122.412-18.666-2.409-.05-7.157 10.365-7.223 15.234z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.96875 0 0 1.2258 182.42 -74.639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.543 290.55h-5.315v3.543h-5.315v3.543h-21.26l-3.543 3.544 1.771 1.771h8.858l1.772-1.771h-8.858l1.772-1.772h12.402l-5.315 5.315h-12.402l-3.544-1.772-3.543 1.771-12.402.001-5.315-5.317 12.402.002 1.771 1.772-8.858-.002 1.772 1.773h8.858l1.772-1.771-3.544-3.544h-19.488v-3.543h-5.315v-3.543h-5.315v-15.945h5.315v-3.543h5.315v-3.543h19.488l3.544-3.544-1.772-1.771h-8.858l-1.772 1.773 8.858-.002-1.771 1.772-12.402.002 5.315-5.317 12.402.001 3.543 1.771 3.544-1.772h12.402l5.315 5.315h-12.402l-1.772-1.772h8.858l-1.772-1.771h-8.858l-1.771 1.771 3.543 3.544h21.26v3.543h5.315v3.543h5.315v15.945z",
    transform: "matrix(1.4884 0 0 1.24 3.502 -39.474)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.59 499.67v24.803h10.629v7.019h10.63v7.087h35.433l14.174 10.63 14.173-10.63h38.976v-7.019l10.63-.068v-7.087h10.63v-24.803h-10.63v-7.086l-10.63.068v-7.155h-38.976l-14.173-10.63-14.174 10.63h-35.433v7.155h-10.63v7.086H375.59z",
    transform: "matrix(.74419 0 0 .62 -392.03 -6.521)",
    stroke: "#faae29",
    strokeWidth: "1pt",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-75.6 296.644l-15.822 10.984v-10.984H-75.6zm31.63 0l15.822 10.985v-10.985H-43.97zm-31.63 28.564l-15.822-10.984v10.984H-75.6zm31.635 0l15.82-10.985v10.985h-15.82zm5.276-21.975l-5.273 4.394h10.547l-5.274-4.394zm-42.188 0l-5.273 4.394h10.547l-5.274-4.394zm0 15.389l-5.273-4.394h10.547l-5.274 4.394zm42.19 0l-5.273-4.394h10.547l-5.274 4.394z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.787 329.602l-5.273-4.394h10.547l-5.274 4.394zm0-21.97l-5.273-4.394h10.547l-5.274 4.394zm0-15.383l-5.273 4.394h10.547l-5.274-4.394zm0 21.968l-5.273 4.394h10.547l-5.274-4.394z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.74419 0 0 .62 -392.03 -6.521)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#faae29",
    d: "M467.72 506.69h14.173v3.543H467.72z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.74419 0 0 .62 -392.03 -6.521)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#c00",
    d: "M414.57 510.24h7.087v3.543h-7.087zm56.69 0h7.087v3.543h-7.087z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.74419 0 0 .62 -392.03 -6.521)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#900",
    d: "M439.37 488.98h14.173v3.543H439.37zm0 7.08h14.173v3.543H439.37z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.74419 0 0 .62 -392.03 -6.521)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#900",
    d: "M435.83 492.52h21.26v3.543h-21.26zm3.54 31.89h14.173v3.543H439.37zm0 7.09h14.173v3.543H439.37z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.74419 0 0 .62 -392.03 -6.521)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#900",
    d: "M435.83 527.95h21.26v3.543h-21.26z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.74419 0 0 .62 -392.03 -6.521)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#faae29",
    d: "M467.72 513.78h14.173v3.543H467.72zm-56.7-7.09h14.173v3.543H411.02zm0 7.09h14.173v3.543H411.02z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.74419 0 0 .62 -392.03 -6.521)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#faae29",
    d: "M407.48 510.24h7.087v3.543h-7.087zm14.17 0h7.087v3.543h-7.087zm42.52 0h7.087v3.543h-7.087zm14.18 0h7.087v3.543h-7.087z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -374.14 -38.912)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -367.57 -38.912)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -361 -38.958)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.51 -41.102)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.68 -41.148)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.57 -36.768)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.68 -36.677)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -353.17 -49.999)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -346.59 -49.999)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -340.02 -50.045)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -350.54 -52.189)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -342.71 -52.235)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -350.59 -47.855)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -342.71 -47.764)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -374.2 -60.904)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -367.62 -60.904)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -361.05 -60.949)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.57 -63.094)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.74 -63.139)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.62 -58.759)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.74 -58.668)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -395.28 -49.817)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -388.71 -49.817)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -382.14 -49.862)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -392.65 -52.007)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -384.82 -52.052)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -392.71 -47.672)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -384.82 -47.581)",
    cx: 413.68,
    rx: 0.886,
    cy: 581.99,
    ry: 0.886
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.575 247.8l4.394-2.058 4.394 2.058h-8.788zm-13.181 0l4.394-2.058 4.394 2.058h-8.788zm-13.181 0l4.394-2.058L117 247.8h-8.788zm26.362-47.35l4.394 2.06 4.394-2.06h-8.788zm-13.181 0l4.394 2.06 4.394-2.06h-8.788zm-13.181 0l4.394 2.06 4.394-2.06h-8.788z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.912 253.98l-5.126 4.119-5.126-4.119-5.126 4.119-5.125-4.119v2.058l3.417 2.06-1.71 2.059v2.06h1.71l1.708-2.06 1.709 2.06h1.709v-2.06l-1.71-2.058 3.418-2.06 3.418 2.06-1.709 2.058v2.06h1.709l1.708-2.06 1.709 2.06h1.709v-2.06l-1.71-2.058 3.418-2.06 3.418 2.059-1.709 2.059v2.06h1.71l1.708-2.06 1.708 2.06h1.709v-2.06l-1.709-2.06 3.417-2.059v-2.058l-5.125 4.118-5.127-4.118zm.001-59.719l-5.126-4.118-5.126 4.118-5.126-4.118-5.125 4.118v-2.058l3.417-2.06-1.71-2.058v-2.06h1.71l1.708 2.06 1.709-2.06h1.709v2.06l-1.71 2.058 3.418 2.059 3.418-2.06-1.709-2.057v-2.06h1.709l1.708 2.06 1.709-2.06h1.709v2.06l-1.71 2.058 3.418 2.059 3.418-2.058-1.709-2.06v-2.059h1.71l1.708 2.06 1.708-2.06h1.709v2.06l-1.709 2.059 3.417 2.06v2.057l-5.125-4.117-5.127 4.117zm38.825 34.322l5.493-4.461-5.493-4.462 5.493-4.46-5.493-4.462h2.745l2.748 2.974 2.745-1.487h2.746v1.487l-2.746 1.487 2.746 1.487v1.487h-2.746l-2.745-1.487-2.747 2.974 2.747 2.975 2.745-1.487h2.746v1.487l-2.746 1.487 2.746 1.487v1.487h-2.746l-2.745-1.487-2.747 2.974 2.745 2.975 2.747-1.488h2.746v1.488l-2.746 1.487 2.746 1.486v1.488h-2.746l-2.747-1.488-2.746 2.975h-2.745l5.491-4.461-5.491-4.462zm-87.896 0l-5.493-4.461 5.493-4.462-5.493-4.46 5.493-4.462h-2.745l-2.748 2.974-2.745-1.487h-2.746v1.487l2.746 1.487-2.746 1.487v1.487h2.746l2.745-1.487 2.747 2.974-2.747 2.975-2.745-1.487h-2.746v1.487l2.746 1.487-2.746 1.487v1.487h2.746l2.745-1.487 2.747 2.974-2.745 2.975-2.747-1.488h-2.746v1.488l2.746 1.487-2.746 1.486v1.488h2.746l2.747-1.488 2.746 2.975h2.745l-5.491-4.461 5.491-4.462z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.24 0 0 1.1622 204.874 -5.458)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#28ae66",
    d: "M-26.575 214.37h1.772v1.772h-1.772z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.24 0 0 1.1622 204.874 -5.458)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#28ae66",
    d: "M-28.346 216.14h1.772v1.772h-1.772zm-8.859 8.86h1.772v1.772h-1.772zm1.772-1.77h1.772v1.772h-1.772zm-58.465 0h1.772v1.772h-1.772zm-8.862-8.86h1.772v1.772h-1.772zm1.78 1.77h1.772v1.772h-1.772zm0-38.97h1.772v1.772h-1.772zm-1.78 1.77h1.772v1.772h-1.772zm10.634-10.63h1.772v1.772h-1.772zM-93.898 170.08h1.772v1.772h-1.772zm56.693-1.77h1.772v1.772h-1.772zm1.772 1.77h1.772v1.772h-1.772zm7.087 7.09h1.772v1.772h-1.772z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.24 0 0 1.1622 204.874 -5.458)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#28ae66",
    d: "M-26.575 178.94h1.772v1.772h-1.772zM-92.126 225h1.772v1.772h-1.772z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.085 224.12l-6.476-.001v-4.047l4.317.002v-3.794h4.318v-3.485h4.317v4.356c-3.575 0-6.476 2.95-6.476 6.969z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.035 224.12l6.476-.001v-4.047l-4.317.002v-3.794h-4.318v-3.485h-4.317v4.356c3.575 0 6.476 2.95 6.476 6.969z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.035 224.12h6.476v4.047l-4.317-.002v3.794h-4.318v3.485h-4.317v-4.356c3.575 0 6.476-2.95 6.476-6.969z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.085 224.12h-6.476v4.047l4.317-.002v3.794h4.318v3.485h4.317v-4.356c-3.575 0-6.476-2.95-6.476-6.969z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.034 224.123h-6.476v-6.97c3.575 0 6.476 3.123 6.476 6.97z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.034 224.117h-6.476v6.969c3.575 0 6.476-3.123 6.476-6.97z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.086 224.117h6.476v6.969c-3.575 0-6.476-3.123-6.476-6.97z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.086 224.123h6.476v-6.97c-3.575 0-6.476 3.123-6.476 6.97z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.378 249.855l-6.59-4.119-6.591 4.12-6.59-4.12-6.59 4.12v-2.059l4.392-2.06-2.197-2.059v-2.06h2.197l2.197 2.06 2.197-2.06H117v2.06l-2.197 2.058 4.394 2.06 4.394-2.06-2.197-2.058v-2.06h2.197l2.196 2.06 2.197-2.06h2.197v2.06l-2.197 2.058 4.394 2.06 4.394-2.058-2.197-2.06v-2.06h2.197l2.197 2.06 2.196-2.06h2.197v2.06l-2.197 2.06 4.394 2.059v2.058l-6.59-4.117-6.591 4.117zm0-51.467l-6.59 4.12-6.591-4.12-6.59 4.12-6.59-4.12v2.059l4.392 2.06-2.197 2.059v2.059h2.197l2.197-2.06 2.197 2.06H117v-2.06l-2.197-2.058 4.394-2.06 4.394 2.06-2.197 2.059v2.059h2.197l2.196-2.06 2.197 2.06h2.197v-2.06l-2.197-2.058 4.394-2.06 4.394 2.06-2.197 2.059v2.059h2.197l2.197-2.06 2.196 2.06h2.197v-2.06l-2.197-2.059 4.394-2.06v-2.058l-6.59 4.118-6.591-4.118zm24.159 30.878l-3.296-5.147 3.296-5.148-3.296-5.147 3.296-5.148h-1.647l-1.65 3.432-1.646-1.716h-1.648v1.716l1.648 1.716-1.648 1.715v1.716h1.648l1.647-1.716 1.648 3.432-1.648 3.432-1.647-1.716h-1.648v1.716l1.648 1.716-1.648 1.716v1.716h1.648l1.647-1.716 1.648 3.431-1.647 3.433-1.648-1.716h-1.648v1.716l1.648 1.715-1.648 1.716v1.716h1.648l1.648-1.716 1.648 3.432h1.647l-3.295-5.148 3.295-5.148z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100.98 177.17l-7.087 7.086v26.575l7.087 7.087h31.889l7.087-7.087v-26.575l-7.087-7.086h-31.889zm-1.772-5.316l-17.717 17.716v15.945l17.717 17.717h35.433l17.716-17.717V189.57l-17.716-17.716h-35.433z",
    transform: "matrix(1.24 0 0 1.1622 231.237 -5.457)",
    stroke: "#000",
    strokeWidth: 0.4,
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 .7748 208.389 135.932)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 -.7748 208.389 312.319)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 -.7748 222.449 312.319)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 .7748 222.449 135.932)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 -.7748 201.359 312.319)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 -.7748 215.419 312.319)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 -.7748 229.479 312.319)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.53 180.71l3.544-3.544h-3.544v3.544z",
    transform: "matrix(1.8599 0 0 -1.7432 293.83 558.694)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.033 229.266l3.296-5.147-3.296-5.148 3.296-5.147-3.296-5.148h1.647l1.65 3.432 1.646-1.716h1.648v1.716l-1.648 1.716 1.648 1.715v1.716h-1.648l-1.647-1.716-1.648 3.432 1.648 3.432 1.647-1.716h1.648v1.716l-1.648 1.716 1.648 1.716v1.716h-1.648l-1.647-1.716-1.648 3.431 1.647 3.433 1.648-1.716h1.648v1.716l-1.648 1.715 1.648 1.716v1.716h-1.648l-1.648-1.716-1.648 3.432h-1.647l3.295-5.148-3.295-5.148z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(1.24 0 0 1.046 253.205 57.34)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99.213 180.71l-3.543 3.544v26.575l3.543 3.543h-5.316l.001-33.662h5.315z",
    transform: "matrix(1.24 0 0 1.1622 222.449 -5.457)",
    stroke: "#000",
    strokeWidth: 0.375,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 .7748 201.359 135.932)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 .7748 215.419 135.932)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-93.898 147.05l3.543 5.315 3.544-5.315h-7.087z",
    transform: "matrix(.992 0 0 .7748 229.479 135.932)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99.212 180.71l-3.544 3.544v26.575l3.544 3.543h-5.315V180.71h5.315z",
    transform: "matrix(-1.24 0 0 1.1622 29.13 -5.457)",
    stroke: "#000",
    strokeWidth: 0.375,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.53 180.71l3.544-3.544h-3.544v3.544z",
    transform: "matrix(-1.8599 0 0 -1.7432 -42.26 558.694)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.53 180.71l3.544-3.544h-3.544v3.544z",
    transform: "matrix(-1.8599 0 0 1.7432 -42.26 -110.448)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.53 180.71l3.544-3.544h-3.544v3.544z",
    transform: "matrix(1.8599 0 0 1.7432 293.83 -110.448)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100.98 177.17l-7.087 7.086v26.575l7.087 7.087h31.889l7.087-7.087v-26.575l-7.087-7.086h-31.889zm-.001-1.773l-8.858 8.858v26.575l8.859 8.858h31.889l8.858-8.858v-26.575l-8.859-8.858h-31.889z",
    transform: "matrix(1.24 0 0 1.1622 231.237 -5.457)",
    stroke: "#000",
    strokeWidth: 0.4,
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(1.24 0 0 1.04607 253.204 61.033)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(1.24 0 0 1.046 253.205 64.752)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(1.24 0 0 1.04607 253.205 68.445)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(1.24 0 0 1.04607 253.205 53.62)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(-1.24 0 0 1.046 -1.63 57.34)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(-1.24 0 0 1.04607 -1.63 61.034)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(-1.24 0 0 1.046 -1.63 64.752)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(-1.24 0 0 1.04607 -1.63 68.446)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.181 154.13h7.087l1.771 1.772-1.771 1.771h-7.087v-3.543z",
    transform: "matrix(-1.24 0 0 1.04607 -1.63 53.621)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100.98 178.94v37.205h8.858v8.858h56.693v-8.858h8.858V178.94h-8.858v-8.858h-56.693v8.858h-8.858zm1.771 1.772v33.661h8.859v8.858h53.15v-8.858h8.858v-33.661H-37.2v-8.859h-53.15v8.859h-8.859z",
    transform: "matrix(1.24 0 0 1.1622 204.874 -5.458)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#970000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.347 69.094l-5.315-7.087v-5.315l-5.315-5.314h-10.63l-8.858-5.315h-28.346l-8.859 5.315h-10.63l-5.315 5.315v5.315l-5.315 7.086v14.173l5.315 7.087v5.315l5.315 5.315h10.63l8.859 5.315h28.346l8.858-5.316h10.63l5.315-5.314v-5.315l5.315-7.087V69.093z",
    transform: "matrix(1.24 0 0 1.1176 215.856 -35.536)",
    stroke: "#000",
    strokeWidth: 0.25,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.081 49.606v5.94l6.59 7.92v5.94l6.591 5.94h13.18l10.985 5.94h15.378l-.001-31.68H73.081z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.248 63.46l-8.024 5.093H94.43l1.598 1.696-3.195 3.395 1.597 1.697 4.793-1.697 1.598 1.697.737-4.535 8.848-5.368-3.16-1.977z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.465 59.501l-8.024 5.092h-4.793l1.598 1.697-3.195 3.394 1.597 1.697 4.793-1.697 1.598 1.697.738-4.535 8.847-5.368-3.16-1.977zm-4.397-7.916l-8.025 5.092H81.25l1.598 1.697-3.195 3.394 1.597 1.697 4.793-1.697 1.598 1.697.738-4.535 8.848-5.368-3.16-1.977z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.494 49.606v-5.94l-6.59-7.92v-5.94l-6.59-5.94h-13.181l-10.985-5.94H125.77l.001 31.68h52.723z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.792 81.285h-4.068l-4.719-3.96h-7.485l-4.068-1.98 2.034-1.98 4.068 1.98h4.068l4.068-5.94 6.102 1.98v3.96h-6.102l6.102 5.94z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.081 49.606v-5.94l6.59-7.92v-5.94l6.591-5.94h13.18l10.985-5.94h15.378l-.001 31.68H73.081z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.792 17.923h-4.068l-4.719 3.96h-7.485l-4.068 1.98 2.034 1.98 4.068-1.98h4.068l4.068 5.94 6.102-1.98v-3.96h-6.102l6.102-5.94z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.788 17.923h4.069l4.718 3.96h7.486l4.068 1.98-2.034 1.98-4.068-1.98h-4.068l-4.068 5.94-6.103-1.98v-3.96h6.103l-6.103-5.94z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.494 49.606v5.94l-6.59 7.92v5.94l-6.59 5.94h-13.181l-10.985 5.94H125.77l.001-31.68h52.723z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.788 81.285h4.069l4.718-3.96h7.486l4.068-1.98-2.034-1.98-4.068 1.98h-4.068l-4.068-5.94-6.103 1.98v3.96h6.103l-6.103 5.94zM98.465 39.703l-8.024-5.091h-4.793l1.598-1.697-3.195-3.395 1.597-1.697 4.793 1.697 1.598-1.697.738 4.535 8.847 5.368-3.16 1.977zm45.863-3.956l8.024-5.092h4.793l-1.598-1.696 3.195-3.395-1.597-1.697-4.793 1.697-1.598-1.697-.738 4.535-8.848 5.368 3.16 1.977z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.248 35.747l-8.024-5.092H94.43l1.598-1.696-3.195-3.395 1.597-1.697 4.793 1.697 1.598-1.697.737 4.535 8.848 5.368-3.16 1.977zm-13.18 11.88l-8.025-5.092H81.25l1.598-1.696-3.195-3.395 1.597-1.697 4.793 1.697 1.598-1.697.738 4.535 8.848 5.368-3.16 1.977z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.982 49.616h2.035l2.034 1.98 2.034-1.98 42.715-.001v27.721h-2.034l2.034 1.981v1.98l-6.102-5.94v-1.98h2.034v1.98h2.034v-1.98L107.25 64.63H93.337v-8.58l-6.184-4.455h-4.068l-2.034 1.98 2.034 1.98h-2.034l-4.069-5.94z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.982 49.596h2.035l2.034-1.98 2.034 1.98 42.715.002V21.876h-2.034l2.034-1.98v-1.98l-6.102 5.94v1.98h2.034v-1.98h2.034v1.98L107.25 34.58H93.337v8.581l-6.184 4.455h-4.068l-2.034-1.98 2.034-1.98h-2.034l-4.069 5.94z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.256 49.595h39.542v23.76l-17.574-9.9h-13.18v-7.92l-8.788-5.94z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.11 39.703l8.025-5.091h4.793l-1.598-1.697 3.195-3.395-1.597-1.697-4.793 1.697-1.598-1.697-.738 4.535-8.848 5.368 3.16 1.977zm4.398 7.924l8.024-5.092h4.793l-1.598-1.696 3.195-3.395-1.597-1.697-4.793 1.697-1.598-1.697-.738 4.535-8.848 5.368 3.16 1.977z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.593 49.596h-2.035l-2.034-1.98-2.034 1.98-42.715.002V21.876h2.034l-2.034-1.98v-1.98l6.102 5.94v1.98h-2.034v-1.98h-2.034v1.98l16.516 8.745h13.913v8.581l6.185 4.455h4.067l2.034-1.98-2.034-1.98h2.034l4.07 5.94z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32 49.617h-39.543v-23.76l17.574 9.9h13.18v7.92l8.788 5.94z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.328 63.46l8.024 5.093h4.793l-1.598 1.696 3.195 3.395-1.597 1.697-4.793-1.697-1.598 1.697-.738-4.535-8.848-5.368 3.16-1.977z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.11 59.501l8.025 5.092h4.793l-1.598 1.697 3.195 3.394-1.597 1.697-4.793-1.697-1.598 1.697-.738-4.535-8.848-5.368 3.16-1.977zm4.398-7.916l8.024 5.092h4.793l-1.598 1.697 3.195 3.394-1.597 1.697-4.793-1.697-1.598 1.697-.738-4.535-8.848-5.368 3.16-1.977z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.593 49.616h-2.035l-2.034 1.98-2.034-1.98-42.715-.001v27.721h2.034l-2.034 1.981v1.98l6.102-5.94v-1.98h-2.034v1.98h-2.034v-1.98l16.516-8.746h13.913v-8.58l6.185-4.455h4.067l2.034 1.98-2.034 1.98h2.034l4.07-5.94z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.32 49.595h-39.543v23.76l17.574-9.9h13.18v-7.92l8.788-5.94z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.256 49.617h39.542v-23.76l-17.574 9.9h-13.18v7.92l-8.788 5.94z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.128 49.606l11.034-5.94h6.59l-2.197-1.98 4.393-3.96-2.196-1.98-6.59 1.98-2.197-1.98-1.015 5.29-12.166 6.263 4.344 2.307zm-8.681-.011l-11.033 5.941h-6.59l2.196 1.98-4.393 3.96 2.196 1.98 6.59-1.98 2.198 1.98 1.015-5.29 12.166-6.264-4.345-2.307z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.447 49.606l-11.033-5.94h-6.59l2.196-1.98-4.393-3.96 2.196-1.98 6.59 1.98 2.198-1.98 1.015 5.29 12.166 6.263-4.345 2.307zm8.681-.011l11.034 5.941h6.59l-2.197 1.98 4.393 3.96-2.196 1.98-6.59-1.98-2.197 1.98-1.015-5.29-12.166-6.264 4.344-2.307z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.608 49.607l13.18-9.9 13.182 9.9-13.181 9.9-13.18-9.9z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.075 53.562l2.034 1.98-2.034 1.98h-2.034l-6.102-7.92h2.034l4.068 5.94h2.034l-2.034-1.98 2.034-1.98h4.068v1.98h-4.068z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.075 45.644l2.034-1.98-2.034-1.98h-2.034l-6.102 7.92h2.034l4.068-5.94h2.034l-2.034 1.98 2.034 1.98h4.068v-1.98h-4.068zm85.429 7.918l-2.034 1.98 2.034 1.98h2.034l6.102-7.92h-2.034l-4.068 5.94h-2.034l2.034-1.98-2.034-1.98h-4.068v1.98h4.068z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.504 45.644l-2.034-1.98 2.034-1.98h2.034l6.102 7.92h-2.034l-4.068-5.94h-2.034l2.034 1.98-2.034 1.98h-4.068v-1.98h4.068zm-44.75-3.96h4.068v15.84h-4.068z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M117.652 45.644h16.272v7.92h-16.272z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.07 170.08l-10.63 5.315v8.858l10.63 5.315h10.63l10.63-5.315v-8.858l-10.63-5.315h-10.63z",
    transform: "matrix(3.4444 0 0 3.7273 -1039.78 -283.145)",
    stroke: "#000",
    strokeWidth: 0.066,
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.458 383.946h2.214v-4.06h4.43v4.06h2.214v-9.474h-2.214v4.06h-4.43v-4.06h-2.214v9.474zm56.1 31.58h2.214v-4.06h4.43v4.06h2.214v-9.474h-2.214v4.06h-4.43v-4.06h-2.214v9.474zm-35.43-47.37h2.214v-4.06h4.43v4.06h2.214v-9.474h-2.214v4.06h-4.43v-4.06h-2.214v9.474zm32.48 0h2.214v-4.06h4.43v4.06h2.214v-9.474h-2.214v4.06h-4.43v-4.06h-2.214v9.474zm20.66 15.79h2.214v-4.06h4.43v4.06h2.214v-9.474h-2.214v4.06h-4.43v-4.06h-2.214v9.474zm0 15.79h2.214v-4.06h4.43v4.06h2.214v-9.474h-2.214v4.06h-4.43v-4.06h-2.214v9.474z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.789 421.848v-34.74h53.15v15.79l-35.433 18.95h-17.717zm.001-69.485v34.74H72.64v-15.791l35.433-18.95h17.717z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.789 352.363v34.74h53.15v-15.791l-35.433-18.95h-17.717zm.001 69.485l-.001-34.74H72.64v15.79l35.433 18.95h17.717z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-177.16 368.5h21.259l-21.259-10.63v10.63zm24.803-1.772l-.001 17.717h-33.661v-14.173h-7.086l-8.858-5.315v-12.402l5.314-5.315h-7.086v17.717h-1.772v-19.489h17.717l35.433 21.26z",
    transform: "matrix(1 0 0 .8913 331.299 44.446)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.042 376.045v22.105h5.314l12.403 6.317 12.403-6.317h5.313v-22.105h-5.313l-12.403-6.318-12.403 6.318h-5.314z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-177.16 368.5h21.259l-21.259-10.63v10.63zm24.803-1.772l-.001 17.717h-33.661v-14.173h-7.086l-8.858-5.315v-12.402l5.314-5.315h-7.086v17.717h-1.772v-19.489h17.717l35.433 21.26z",
    transform: "matrix(-1 0 0 -.8913 -79.72 729.765)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-177.16 368.5h21.259l-21.259-10.63v10.63zm24.803-1.772l-.001 17.717h-33.661v-14.173h-7.086l-8.858-5.315v-12.402l5.314-5.315h-7.086v17.717h-1.772v-19.489h17.717l35.433 21.26z",
    transform: "matrix(-1 0 0 .8913 -79.72 44.446)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-177.16 368.5h21.259l-21.259-10.63v10.63zm24.803-1.772l-.001 17.717h-33.661v-14.173h-7.086l-8.858-5.315v-12.402l5.314-5.315h-7.086v17.717h-1.772v-19.489h17.717l35.433 21.26z",
    transform: "matrix(1 0 0 -.8913 331.3 729.765)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.278 399.746h2.214v-4.737h4.43v4.737h2.214v-11.053h-2.214v4.737h-4.43v-4.737h-2.214v11.053zm21.25 15.79h2.214V410.8h4.43v4.737h2.214v-11.053h-2.214v4.737h-4.43v-4.737h-2.214v11.053zm-21.25-41.06h2.214v4.738h4.43v-4.738h2.214v11.054h-2.214v-4.738h-4.43v4.738h-2.214v-11.054zm21.25-15.792h2.214v4.738h4.43v-4.738h2.214v11.054h-2.214V365h-4.43v4.738h-2.214v-11.054zm33.67 56.852h2.214V410.8h4.43v4.737h2.214v-11.053h-2.214v4.737h-4.43v-4.737h-2.214v11.053zm21.26-30.01h2.214v-4.737h4.43v4.737h2.214v-11.053h-2.214v4.737h-4.43v-4.737h-2.214v11.053z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.198 415.536h2.214V410.8h4.43v4.737h2.214v-11.053h-2.214v4.737h-4.43v-4.737h-2.214v11.053z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.198 415.536h2.214V410.8h4.43v4.737h2.214v-11.053h-2.214v4.737h-4.43v-4.737h-2.214v11.053zm21.26-15.8h2.214V395h4.43v4.737h2.214v-11.053h-2.214v4.737h-4.43v-4.737h-2.214v11.053zm-21.26-30h2.214V365h4.43v4.737h2.214v-11.053h-2.214v4.737h-4.43v-4.737h-2.214v11.053z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.563 387.106l7.087-5.759h3.543v2.879h-3.543v1.44h5.314v-5.758h-5.314v-4.318h-7.087v4.317h1.772v-2.88h3.543v2.88l-7.086 5.758-7.087-5.757v-2.878h3.543v2.878h1.772v-4.318h-7.087v4.318h-5.315v5.759h5.315v-1.44h-3.544v-2.88h3.544l7.087 5.758-7.087 5.757h-3.543v-2.878h3.543v-1.44h-5.314v5.758h5.314v4.318l7.087.001v-4.319h-1.771v2.88h-3.543v-2.88l7.085-5.757 7.088 5.759v2.878h-3.543v-2.878h-1.772v4.317h7.086v-4.317l5.315-.002v-5.757h-5.315v1.44h3.544v2.879h-3.544l-7.087-5.758z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 .92857 198.43 17.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-122.352 134.285l3.43-3.73h20.573l15.43-16.784h20.574l15.43 16.784h20.575l3.429 3.729-3.429 3.73h-20.574l-15.43 16.784H-82.92l-15.43-16.784h-20.574l-3.43-3.729z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05 391.54l1.903-1.949h22.834l17.126-19.489h19.029l17.126 19.489h22.835l1.903 1.949-1.903 1.948h-22.835l-15.223 17.54h-22.834l-15.224-17.54h-22.834l-1.903-1.948z",
    transform: "matrix(.93104 0 0 .90908 -466.86 -221.29)",
    stroke: "#000",
    strokeWidth: 0.272,
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64.071 136.148l6.858 7.458-3.428 3.73-1.715-1.865h-1.714v1.865l1.714 1.865h3.43l3.428-3.73v-3.73l-6.857-7.458 6.857-7.46v-3.73l-3.429-3.729h-3.428l-1.715 1.864v1.865h1.715l1.714-1.865 3.428 3.73-6.857 7.46-6.859-7.46 6.859-7.46v-1.863h-1.715l-6.857 7.458-6.859-7.46h-1.715v1.865l6.859 7.46-6.859 7.46-6.858-7.46 3.429-3.73 1.715 1.865h1.714v-1.865l-1.714-1.864h-3.43l-3.429 3.73v3.729l6.859 7.46-6.859 7.46v3.729l3.43 3.73h3.429l1.714-1.865v-1.865h-1.714l-1.715 1.865-3.429-3.73 6.858-7.46 6.858 7.46-6.858 7.46v1.864h1.714l6.859-7.46 6.858 7.46h1.714v-1.865l-6.858-7.46 6.858-7.458zm-8.572-9.325l-6.859 7.46 6.859 7.46 6.858-7.46-6.858-7.46zm-10.274 27.967v14.918l1.715-1.865 1.715 1.865 1.714-1.865 1.714 1.865 1.715-1.865 1.714 1.865 1.715-1.865 1.715 1.865 1.714-1.865 1.715 1.865 1.713-1.865 1.715 1.865V154.79h-20.574zm20.564-41V98.872l-1.715 1.865-1.715-1.865-1.714 1.865-1.714-1.865-1.715 1.865-1.714-1.865-1.715 1.865-1.715-1.865-1.714 1.865-1.715-1.865-1.713 1.865-1.715-1.865v14.918h20.574zm29.148 16.79v-14.918l-1.715 1.865-1.713-1.865-1.715 1.865-1.715-1.865-1.714 1.865-1.715-1.865-1.714 1.865-1.714-1.865v14.918h13.715zm-65.15 0v-14.918l-1.715 1.865-1.713-1.865-1.715 1.865-1.715-1.865-1.714 1.865-1.715-1.865-1.714 1.865-1.714-1.865v14.918h13.715zm65.15 7.43v14.918l-1.715-1.865-1.713 1.865-1.715-1.865-1.715 1.865-1.714-1.865-1.715 1.865-1.714-1.865-1.714 1.865V138.01h13.715zm-65.15 0v14.918l-1.715-1.865-1.713 1.865-1.715-1.865-1.715 1.865-1.714-1.865-1.715 1.865-1.714-1.865-1.714 1.865V138.01h13.715z",
    fill: "#faae29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.347 154.79v9.324l1.714-1.866 1.715 1.866 1.714-1.866 1.714 1.866 1.715-1.866 1.714 1.866 1.715-1.866 1.714 1.866 1.715-1.866v-24.242l-15.43 16.784zm-20.586 0v9.325l-1.715-1.866-1.715 1.866-1.714-1.866-1.714 1.866-1.715-1.866-1.714 1.866-1.715-1.866-1.714 1.866-1.715-1.866.001-24.243 15.43 16.784zm0-41v-9.324l-1.714 1.866-1.715-1.866-1.714 1.866-1.714-1.866-1.715 1.866-1.714-1.866-1.715 1.866-1.714-1.866-1.715 1.866v24.242l15.43-16.784zm20.586 0v-9.324l1.714 1.866 1.715-1.866 1.714 1.866 1.714-1.866 1.715 1.866 1.714-1.866 1.715 1.866 1.714-1.866 1.715 1.866v24.242l-15.43-16.784zm-49.731 35.416l-1.715-1.865-1.713 1.865-1.714-1.865-1.715 1.865-1.715-1.865-1.715 1.865-1.713-1.865-1.715 1.865v-29.838l1.714 1.866 1.714-1.866 1.715 1.866 1.714-1.866 1.715 1.866 1.714-1.866 1.714 1.866 1.715-1.866v11.19h-6.857l-3.43 3.73 3.43 3.73h6.857v11.188zm78.876 0l1.715-1.865 1.713 1.865 1.714-1.865 1.715 1.865 1.715-1.865 1.715 1.865 1.713-1.865 1.715 1.865v-29.838l-1.714 1.866-1.714-1.866-1.715 1.866-1.714-1.866-1.715 1.866-1.714-1.866-1.714 1.866-1.715-1.866v11.19h6.857l3.43 3.73-3.43 3.73h-6.857v11.188z",
    fill: "#28ae66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-91.36 155.978s-1.428 1.474-1.428 2.21c-.028.687 1.524 2.227 2.143 2.211.81.016 2.143-1.474 2.143-2.21 0-.737-1.43-2.211-1.43-2.211v-2.948s3.104 5.068 3.104 2.857c0-1.586-3.103-4.331-3.103-4.331h-1.429s-3.103 3.214-3.103 4.33c0 2.212 3.103-2.856 3.103-2.856v2.948z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.497 161.669s-1.715 2.063-1.715 3.095c-.034.962 1.829 3.118 2.572 3.095.971.023 2.572-2.063 2.572-3.095s-1.715-3.095-1.715-3.095v-4.127s3.037 6.751 3.037 3.656c0-2.001-3.037-5.72-3.037-5.72h-1.714s-3.506 4.656-3.037 5.72c0 3.095 3.037-3.656 3.037-3.656v4.127z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#28ae66",
    transform: "matrix(.96774 0 0 1.0526 -482.4 -277.85)",
    cx: 403.94,
    rx: 3.543,
    cy: 391.54,
    ry: 1.772
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#28ae66",
    transform: "matrix(.96774 0 0 1.0526 -463.54 -277.85)",
    cx: 403.94,
    rx: 3.543,
    cy: 391.54,
    ry: 1.772
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#28ae66",
    transform: "matrix(.96774 0 0 1.0526 -444.69 -277.85)",
    cx: 403.94,
    rx: 3.543,
    cy: 391.54,
    ry: 1.772
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-91.72 112.76s-1.428-1.474-1.428-2.21c-.028-.688 1.524-2.228 2.143-2.211.81-.017 2.143 1.473 2.143 2.21 0 .737-1.43 2.211-1.43 2.211v2.948s3.104-5.068 3.104-2.857c0 1.586-3.103 4.33-3.103 4.33h-1.429s-3.103-3.213-3.103-4.33c0-2.21 3.103 2.857 3.103 2.857v-2.948z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.857 107.062s-1.715-2.063-1.715-3.095c-.034-.962 1.829-3.118 2.572-3.095.971-.023 2.572 2.063 2.572 3.095s-1.715 3.095-1.715 3.095v4.127s3.037-6.751 3.037-3.656c0 2.001-3.037 5.72-3.037 5.72h-1.714s-3.506-4.656-3.037-5.72c0-3.095 3.037 3.656 3.037 3.656v-4.127z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54.86 155.978s-1.428 1.474-1.428 2.21c-.028.687 1.524 2.227 2.143 2.211.81.016 2.143-1.474 2.143-2.21 0-.737-1.43-2.211-1.43-2.211v-2.948s3.104 5.068 3.104 2.857c0-1.586-3.103-4.331-3.103-4.331h-1.429s-3.103 3.214-3.103 4.33c0 2.212 3.103-2.856 3.103-2.856v2.948zm-.36-43.218s-1.428-1.474-1.428-2.21c-.028-.688 1.524-2.228 2.143-2.211.81-.017 2.143 1.473 2.143 2.21 0 .737-1.43 2.211-1.43 2.211v2.948s3.104-5.068 3.104-2.857c0 1.586-3.103 4.33-3.103 4.33h-1.429s-3.103-3.213-3.103-4.33c0-2.21 3.103 2.857 3.103 2.857v-2.948z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-106.273 145.593s-1.9 1.383-1.9 2.074c-.037.644 2.026 2.089 2.85 2.074 1.076.015 2.85-1.383 2.85-2.074 0-.691-1.9-2.074-1.9-2.074v-2.765s3.364 4.523 3.364 2.45c0-1.342-3.365-3.833-3.365-3.833h-1.9s-3.882 3.119-3.363 3.832c0 2.074 3.364-2.45 3.364-2.45v2.766zm-.4-21.122s-1.9-1.383-1.9-2.074c-.037-.644 2.026-2.09 2.85-2.074 1.076-.015 2.85 1.383 2.85 2.074 0 .691-1.9 2.074-1.9 2.074v2.765s3.364-4.524 3.364-2.45c0 1.342-3.365 3.833-3.365 3.833h-1.9s-3.882-3.12-3.363-3.832c0-2.074 3.364 2.45 3.364 2.45v-2.766zm66.25 20.679s-1.9 1.384-1.9 2.075c-.037.644 2.026 2.089 2.85 2.074 1.076.015 2.85-1.383 2.85-2.074 0-.691-1.9-2.074-1.9-2.074v-2.765s3.364 4.523 3.364 2.45c0-1.342-3.365-3.833-3.365-3.833h-1.9s-3.882 3.119-3.363 3.832c0 2.074 3.364-2.45 3.364-2.45v2.766zm-.4-21.119s-1.9-1.383-1.9-2.074c-.037-.644 2.026-2.09 2.85-2.074 1.076-.015 2.85 1.383 2.85 2.074 0 .691-1.9 2.074-1.9 2.074v2.765s3.364-4.524 3.364-2.45c0 1.342-3.365 3.833-3.365 3.833h-1.9s-3.882-3.12-3.363-3.832c0-2.074 3.364 2.45 3.364 2.45v-2.766z",
    fill: "#ca3745"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.285 145.363c-.615-1.277-.453-1.86-.453-2.597-.028-.687 1.716-2.025 2.336-2.009.809-.016 2.143 1.474 2.143 2.21 0 .737.034 1.374-.298 2.644l-.893-2.154c-1.084 3.056-1.143 3.127-1.787-.074l-1.048 1.98zm.06-21.433c-.615 1.278-.453 1.862-.453 2.598-.028.687 1.716 2.025 2.336 2.009.809.016 2.143-1.474 2.143-2.21 0-.737.034-1.374-.298-2.644l-.893 2.154c-1.084-3.056-1.143-3.127-1.787.074l-1.048-1.98zm92.42 21.163c-.615-1.277-.453-1.86-.453-2.597-.028-.687 1.716-2.025 2.336-2.009.809-.016 2.143 1.474 2.143 2.21 0 .737.034 1.374-.298 2.644l-.893-2.154c-1.084 3.056-1.143 3.127-1.787-.074l-1.048 1.98zm.05-21.438c-.615 1.277-.453 1.86-.453 2.597-.028.687 1.716 2.025 2.336 2.009.809.016 2.143-1.474 2.143-2.21 0-.737.034-1.374-.298-2.644l-.893 2.154c-1.084-3.056-1.143-3.127-1.787.074l-1.048-1.98z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.16 177.16v-5.315H99.216v-10.63H85.043v-3.543H72.641v-31.89h12.402v-3.543h14.173v-10.63h15.944v-5.315h21.26v5.315h15.945v10.63h14.173v3.543h12.402v31.89h-12.402v3.543h-14.173v10.63H136.42v5.315h-21.26zm-1.772 1.772v-5.315H97.444v-10.63H83.271v-3.543H70.869v-35.433h12.402v-3.544h14.173v-10.63h15.945v-5.315h24.803v5.315h15.945v10.63h14.173v3.544h12.402v35.433H168.31v3.543h-14.173v10.63h-15.945v5.315h-24.804z",
    transform: "matrix(1 0 0 .99999 -198.43 -7.085)",
    stroke: "#000",
    strokeWidth: 0.125,
    fill: "#ca3745"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.aebbec68862465e96838fb34c50c5c1b.svg";
export { ForwardRef as ReactComponent };